<template>
  <slot />
</template>

<script lang="ts">
export default {
  inheritAttrs: false
};
</script>
<script lang="ts" setup>
import { usePopupContainer } from './PopupContainer';
usePopupContainer();
</script>
